import { HasValueParamUtils } from '.'
import TypeValueUtils from '@/core/utils/TypeValueUtils'

export default class ParamUtils {
	constructor(configParams) {
		this.hasValueParam = new HasValueParamUtils(configParams)
	}

	ObjectsToParams(paramArray) {
		let params = []
		let param

		paramArray.forEach((obj) => {
			param = this.ObjectToParams(obj)
			if (this.hasValueParam.hasValue(param)) {
				params.push(param)
			}
		})

		return params.join('&')
	}

	ObjectToParams(paramObj) {
		const entries = Object.entries(paramObj)
		let params = ''

		entries.forEach((keyValuePair) => {
			const key = keyValuePair[0]
			const value = keyValuePair[1]

			if (this.hasValueParam.hasValue(value)) {
				params += this._concatParam(key, value)
			}
		})
		return params.substring(1)
	}

	_concatParam(key, value) {
		return `&${key}=${this._encodeURIComponent(value)}`
	}

	_encodeURIComponent(str) {
		str = this._normalizeStr(str)

		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16)
		})
	}

	_normalizeStr(str) {
		if (!str || !TypeValueUtils.isString(str)) return str
		return str.trim()
	}
}
